module.exports = __webpack_public_path__ + "static/media/screen 2.257169cd.png";